export default {
  methods: {
    changePanes(e){
      const newSizes = {}
      e.forEach(v => {
        this.currentSizes[v.paneId] = v.size
      })
      this.currentSizes = {
        ...this.currentSizes,
        ...newSizes
      }
      setTimeout(() => {
        this.mapResized()
      })
    },
    mapResized() {}
  }
}



// WEBPACK FOOTER //
// ./src/mixins/panes.js